import styled, { css } from 'styled-components';
import Image from '../../../../image';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptHeaderImage
 */
export const ReceiptHeaderImageStyles = ({ theme }) => css `
	order: 2;
	margin: 0;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	padding: ${pxToRem(theme.spacing[200])} 0;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		order: unset;
		padding: 0 0 ${pxToRem(theme.spacing['200'])} 0;
		border-top-left-radius: ${pxToRem(theme.borderRadius.m)};
		border-top-right-radius: ${pxToRem(theme.borderRadius.m)};
	}
`;
export const StyledReceiptHeaderImage = styled(Image) `
	${ReceiptHeaderImageStyles}
`;
